import React from 'react'
import { EditLink } from './Home'

export default class QuickLinksEditor extends React.Component{
  constructor(props){
    super(props)
    this.state = {
      links: [...props.links],
      newIconIndex: null
    }
  }
  getLinks = () => this.state.links
  insertAbove = index => {
    this.setState(state => ({
      links: [
        ...state.links.slice(0, index),
        { label: "", href: "", targetBlank: false },
        ...state.links.slice(index)
      ],
      newIconIndex: index
    }))
  }
  insertBelow = index => {
    this.setState(state => ({
      links: [
        ...state.links.slice(0, index + 1),
        { label: "", href: "", targetBlank: false },
        ...state.links.slice(index + 1)
      ],
      newIconIndex: index + 1
    }))
  }
  deleteLink = index => {
    this.setState(state => ({
      links: [...state.links.slice(0, index), ...state.links.slice(index + 1)]
    }))
  }
  addNewLink = () => {
    this.setState(state => ({
      links: [...state.links, { label: "", href: "", targetBlank: false }],
      newIconIndex: state.links.length
    }))
  }
  setRowValueByIndex = ({ name, value, index }) => {
    this.setState(state => ({
      links: [
        ...state.links.slice(0, index),
        { ...state.links[index], [name]: value },
        ...state.links.slice(index + 1)
      ]
    }))
  }
  clearNewIcon = () => {
    this.setState({
      newIconIndex: null
    })
  }
  render(){
    const { links = [] } = this.state;
    return(
      <div className='quick-links-editor wizard'>
        {
          links.map((link, i) => (
            <EditLink
              themeable
              onChange={this.setRowValueByIndex}
              insertAbove={this.insertAbove}
              insertBelow={this.insertBelow}
              deleteLink={this.deleteLink}
              clearNewIcon={this.clearNewIcon}
              isNew={this.state.newIconIndex === i}
              {...link}
              index={i}
              key={i}
            />
          ))
        }
        <button type="button" onClick={this.addNewLink} className="add-link custom-focus">
          Add new link
        </button>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Home/QuickLinksEditor.js